
export default function NotFoundView() {
    return (
        <div style={{ color: "white" }}>NotFoundView</div>
    )
}
